import { Component, Input, OnInit } from '@angular/core';

import { UserAccountRegActionDto, UserAccountRegDto } from 'src/app/core/dtos/dto';
import { AccountService } from 'src/app/core/services/account.service';
import { RegAction } from '../action';
import { ActionHelper } from '../action.helper';

@Component({
  selector: 'app-test-actions',
  templateUrl: './test-actions.component.html',
  styleUrls: ['./test-actions.component.scss']
})
export class TestActionsComponent implements OnInit {
  @Input() reg: UserAccountRegDto;
  @Input() isUpcomingTest?: boolean;

  actions: UserAccountRegActionDto;
  regActions: RegAction[];

  constructor(
    private accountService: AccountService,
    private actionsHelper: ActionHelper
  ) { }

  ngOnInit(): void {
    this.accountService.getRegActions(this.reg.regId)
      .subscribe(
        result => {
          this.actions = result.content;
          this.regActions = this.actionsHelper.getRegistrationActions(this.actions, this.reg, this.isUpcomingTest);
        });
  }

}
